let getProductByID = (products, id) => {
    if(products)
        return products.filter(p => p.id === id)[0]
    else return []
}

export default getProductByID;